// extracted by mini-css-extract-plugin
export var container = "titleCard-module--container--ee4GO";
export var desc = "titleCard-module--desc--0Gq9k";
export var icon = "titleCard-module--icon--qAbvJ";
export var title = "titleCard-module--title--4DmiN";